<template>
  <div class="w-full dyn_form">
    <!-- <pre>{{ errors }}</pre> -->
    <!-- {{custom_fields_required}} -->
    <!-- For Dynamic Field required Labels-->
    <!-- {{validatorScope}} -->

    <vs-col
      vs-type="flex"
      vs-justify="left"
      vs-lg="6"
      vs-sm="6"
      vs-xs="12"
      vs-w="12"
      style="padding: 5px 4px"
      class="flex-wrap"
      v-for="(custom_field, index) in custom_fields_required"
      :key="custom_field.attribute_id + index"
    >
      <!-- To Check Text Field -->
      <label v-if="custom_field.inputtype === 'text'" class="vs-input--label">
        {{ custom_field.label }}
        <span :class="custom_field.is_required ? 'required' : ''"> </span>
      </label>

      <vs-input
        v-if="custom_field.inputtype === 'text'"
        class="w-full"
        v-validate="custom_field.is_required?'required':''"
        v-model="form[custom_field.field]"
        :data-vv-name="`${custom_field.label}`"
        :name="`${custom_field.label}`"
      />

      <div
        v-if="
          errors.has(`${validatorScope}.${custom_field.label}`) &&
          custom_field.inputtype === 'text'
        "
        style="color: red"
        class="invalid-feedback"
      >
        {{
          errors.first(`${validatorScope}.${custom_field.label}`)
        }}
      </div>

      <!-- To Check Text Field -->

      <!-- To Check Number Field -->
      <label v-if="custom_field.inputtype === 'number'" class="vs-input--label">{{custom_field.label}}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>
      <vs-input
        v-if="custom_field.inputtype === 'number'"
        class="w-full"
        v-validate="custom_field.is_required?'required|numeric':''"
        v-model="form[custom_field.field]"
        :data-vv-name="`${custom_field.label}`"
        :name="`${custom_field.label}`"
      />
      <div
        v-if="
          errors.has(`${validatorScope}.${custom_field.label}`) &&
          custom_field.inputtype === 'number'
        "
        style="color: red"
        class="invalid-feedback"
      >
        {{
          errors.first(`${validatorScope}.${custom_field.label}`)
        }}
      </div>
      <!-- To Check Number Field -->

      <!-- To Check Text Area Field -->
      <label v-if="custom_field.inputtype === 'textarea'" class="vs-input--label">Textarea<span :class="custom_field.is_required ? 'required' : ''"> </span></label>
      <vs-textarea
        v-if="custom_field.inputtype === 'textarea'"
        :data-vv-name="`${custom_field.label}`"
        :name="`${custom_field.label}`"
        class="w-full"
        v-validate="custom_field.is_required?'required':''"
        v-model="form[custom_field.field]"
        
      />

      <div
        v-if="
          errors.has(`${validatorScope}.${custom_field.label}`) &&
          custom_field.inputtype === 'textarea'
        "
        style="color: red"
        class="invalid-feedback"
      >
        {{
          errors.first(`${validatorScope}.${custom_field.label}`)
        }}
      </div>
      <!-- To Check TextArea Field -->

      <!-- To Check Checkbox Field -->

      <li v-if="custom_field.inputtype === 'checkbox'">
        <label class="vs-input--label">{{ custom_field.label }}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>
        <div class="flex flex-wrap">
          <vs-checkbox
            class="p-2"
            v-validate="custom_field.is_required?'required':''"
            :data-vv-name="`${custom_field.label}`"
            :name="`${custom_field.label}`"
            v-for="multivalue in custom_field.multivalue"
            :key="multivalue.id"
            v-model="form[custom_field.field]"
            :vs-value="multivalue.optionsvaluename"
          >
            {{ multivalue.optionsvaluename }}
          </vs-checkbox>
        </div>
        <div
          v-if="
            errors.has(
              `${validatorScope}.${custom_field.label}`
            ) && custom_field.inputtype === 'checkbox'
          "
          style="color: red"
          class="invalid-feedback"
        >
          {{
            errors.first(
              `${validatorScope}.${custom_field.label}`
            )
          }}
        </div>
      </li>
      <!-- To Check Checkbox Field -->

      <!-- To Check Radio Field -->
      <li class="w-full" v-if="custom_field.inputtype === 'radio'">
        <label class="vs-input--label">{{ custom_field.label }}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>

        <ul class="flex flex-wrap w-full">
          <li
            v-for="multivalue in custom_field.multivalue"
            :key="multivalue.id"
            class="p-2"
          >
            <div class="flex flex-wrap">
              <vs-radio
                v-validate="custom_field.is_required?'required':''"
                v-model="form[custom_field.field]"
                :vs-name="custom_field.label"
                :data-vv-name="custom_field.label"
                :name="custom_field.label"
                :vs-value="multivalue.optionsvaluename"
                :label="custom_field.label"
              >
                {{ multivalue.optionsvaluename }}
              </vs-radio>
            </div>
          </li>
        </ul>
        <div
          v-if="
            errors.has(
              `${validatorScope}.${custom_field.label}`
            ) && custom_field.inputtype === 'radio'
          "
          style="color: red"
          class="invalid-feedback"
        >
          {{
            errors.first(
              `${validatorScope}.${custom_field.label}`
            )
          }}
        </div>
      </li>

      <!-- To Check Boolean Field -->
      <li v-if="custom_field.inputtype === 'boolean'">
        <label class="vs-input--label">{{ custom_field.label }}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>

        <ul class="w-full">
          <!-- <li
                          v-for="multivalue in custom_field.multivalue"
                          :key="multivalue.id"
                        > -->
          <li>
            <div class="flex flex-wrap">
              <vs-radio
                v-validate="custom_field.is_required?'required':''"
                id="radiodynamic"
                v-model="form[custom_field.field]"
                :vs-name="custom_field.label"
                :data-vv-name="custom_field.label"
                :name="custom_field.label"
                vs-value="1"
              >
                True
              </vs-radio>

              <vs-radio
                v-validate="custom_field.is_required?'required':''"
                id="radiodynamic"
                v-model="form[custom_field.field]"
                :vs-name="custom_field.label"
                :data-vv-name="custom_field.label"
                :name="custom_field.label"
                vs-value="0"
              >
                False
              </vs-radio>
            </div>
          </li>
           <div
            v-if="
              errors.has(
                `${validatorScope}.${custom_field.label}`
              )
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{
              errors.first(
                `${validatorScope}.${custom_field.label}`
              )
            }}
          </div>
        </ul>
      </li>

      <!-- To Check Date Field -->
      <li
        v-if="custom_field.inputtype === 'datetime'"
        style="width: 100%"
      >
        <label class="vs-input--label">{{ custom_field.label }}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>

        <ul class="w-full">
          <!-- <flat-pickr /> -->
          <flat-pickr
            v-validate="custom_field.is_required?'required':''"
            style="width: 100%"
            v-model="form[custom_field.field]"
            :config="{altInput: true,altFormat: 'j F, Y',dateFormat: 'Y-m-d'}"
            :class="{
              input: true,
              'is-danger': errors.has(`${custom_field.label}`),
            }"
            :data-vv-name="`${custom_field.label}`"
            :name="`${custom_field.label}`"
          />
          <div
            v-if="
              errors.has(
                `${validatorScope}.${custom_field.label}`
              ) && custom_field.inputtype === 'datetime '
            "
            style="color: red"
            class="invalid-feedback"
          >
            {{
              errors.first(
                `${validatorScope}.${custom_field.label}`
              )
            }}
          </div>
          <!-- <input type="date"  v-model="form[custom_field.field]"/> -->
        </ul>

        <div
          v-if="
            errors.has(
              `${validatorScope}.${custom_field.label}`
            ) && custom_field.inputtype === 'datetime'
          "
          style="color: red"
          class="invalid-feedback"
        >
          {{
            errors.first(
              `${validatorScope}.${custom_field.label}`
            )
          }}
        </div>
      </li>

      <!-- To Check Select Field -->

      <li class="w-full" v-if="custom_field.inputtype === 'select'">
        <label class="vs-input--label">{{ custom_field.label }}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>
        <select
        class="cstm_select"
          v-model="form[custom_field.field]"
          v-validate="custom_field.is_required?'required':''"
          :data-vv-name="`${custom_field.label}`"
          :name="`${custom_field.label}`"
          id="selectdynamic"
          v-if="custom_field.inputtype === 'select'"
          style="width: 100%"
        >
          <option
            v-for="multivalue in custom_field.multivalue"
            :key="multivalue.id"
            :value="multivalue.optionsvaluename"
          >
            {{ multivalue.optionsvaluename }}
          </option>
        </select>

        <div
          v-if="
            errors.has(
              `${validatorScope}.${custom_field.label}`
            ) && custom_field.inputtype === 'select'
          "
          style="color: red"
          class="invalid-feedback"
        >
          {{
            errors.first(
              `${validatorScope}.${custom_field.label}`
            )
          }}
        </div>
      </li>

      <!-- check multiselect -->
      <li class="w-full" v-if="custom_field.inputtype === 'multiselect'">
        <label class="vs-input--label">{{ custom_field.label }}<span :class="custom_field.is_required ? 'required' : ''"> </span></label>
        <v-select
          class="w-full"
          multiple
          :data-vv-name="`${custom_field.label}`"
          :name="`${custom_field.label}`"
          v-validate="custom_field.is_required?'required':''"
          label="optionsvaluename"
          :closeOnSelect="false"
          v-model="form[custom_field.field]"
          :reduce="(option) => option.optionsvaluename"
          :options="custom_field.multivalue"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </li>

      <div
        v-if="
          errors.has(`${validatorScope}.${custom_field.label}`) &&
          custom_field.inputtype === 'multiselect'
        "
        style="color: red"
        class="invalid-feedback"
      >
        {{
          errors.first(`${validatorScope}.${custom_field.label}`)
        }}
      </div>
      <!-- multiselect -->
    </vs-col>
    <!-- For Dynamic Field required Labels-->
  </div>
</template>

<script>
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  name: 'DynamicComponent',
  components: {
    vSelect,
    flatPickr
  },
  inject: {
    $validator: '$validator'
  },
  props: {
    value: {
      required: true,
      type: Object,
      default: () => {}
    },
    custom_fields_required: {
      required: true,
      type: Array,
      default: () => []
    },
    validatorScope: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    form: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}
.required:after {
  content: " *";
  color: red;
}
li {
  list-style-type: none;
}
</style>
<style>
.dyn_form {
  display: flex;
  flex-wrap: wrap;
}
.dyn_form input {
  width: 100%;
}
</style>